var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 15,
  viewBox: "0 0 14 15",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 8.03147L5.48533 9.3011C5.52038 9.34395 5.56322 9.379 5.60995 9.40236C5.66058 9.42573 5.71121 9.44131 5.76574 9.44131C5.82026 9.44131 5.87089 9.42963 5.92152 9.40626C5.97215 9.38289 6.01499 9.35173 6.04615 9.30889L9.20075 5.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 13.4901C10.3079 13.4901 13 10.8079 13 7.49007C13 4.17219 10.3079 1.5 7 1.5C3.69205 1.5 1 4.18212 1 7.5C1 10.8179 3.68212 13.5 7 13.5V13.4901Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgCircleCheck;